import {Style, Icon} from 'ol/style';
import xml2js from 'xml2js';
import ky from 'ky';

import { parser as gradientCssParser } from '../../utils/Gradient/parser.js';
import { applicator as gradientSvgApplicator } from '../../utils/Gradient/svg.js';

const ICONS_CACHE = {};

const ICONS_CACHE_LOADER = {};

const defered_icon_loader = async function(src) {
	return new Promise((resolve, reject) => {
		if(typeof ICONS_CACHE_LOADER[src] === 'undefined')
		{
			ICONS_CACHE_LOADER[src] = ky.get(src).text();
		}
		ICONS_CACHE_LOADER[src]
			.then((value) => {
				resolve(value);
			})
			.catch((error) => {
				resolve(false);
			})
	});
}

export const icon_svg = async (styleDef,layer,__style) => {

	const ratio = layer.ratio || 1;
	const iconSize = styleDef.size * ratio;

	const anchor = layer.anchor || [0.5,0.5]
	if(styleDef.anchor)
	{
		anchor[0] = anchor[0] + (styleDef.anchor[0] - 0.5)/ratio;
		anchor[1] = anchor[1] + (styleDef.anchor[1] - 0.5)/ratio;
	}

	var icon = typeof ICONS_CACHE[layer.src] !== 'undefined' ? ICONS_CACHE[layer.src]+"" : false;
	if(icon === false)
	{
		ICONS_CACHE[layer.src] = await defered_icon_loader(layer.src);
		icon = ICONS_CACHE[layer.src]+"";
	}

	if(!icon)
		return ;

	try {
		icon = await xml2js.parseStringPromise(icon);
	} catch(e) {
		return ;
	}

	icon.svg.$.width = iconSize+'px';
	icon.svg.$.height = iconSize+'px';

	var builder = new xml2js.Builder();
	icon = builder.buildObject(icon);

	if(layer.fill)
	{
		const gradient = gradientCssParser(layer.fill);
		if(gradient)
		{
			icon = gradientSvgApplicator(gradient,icon);
		}
		else
		{
			if(icon.indexOf('fill=')>=0)
			{
				icon = icon.replaceAll(/fill="[^"]+"/g,`fill="${layer.fill}"`);
			}
			else
			{
				icon = icon.replace(/(<svg[^>]+)>/,`$1><g fill="${layer.fill}">`);
				icon = icon.replace('</svg>',`</g></svg>`);
			}
		}
	}

	if(layer?.css?.length > 0)
	{
		var svgHandler = document.createElement('div');
		svgHandler.innerHTML = icon;
		layer.css.forEach((css) => {
			let nodes = svgHandler.querySelectorAll(css.selector);
			nodes.forEach((node) => {
				node.style = css.rules
			});
		})
		icon = svgHandler.innerHTML;
	}

	if(layer.stroke)
	{
		icon = icon.replace(/(<svg[^>]+)>/,`$1>
			<g stroke="${layer.stroke.color}" stroke-width="${layer.stroke.width}">`
		);
		icon = icon.replace('</svg>',`</g></svg>`);
	}

	if(layer.blur)
	{
		icon = icon.replace(/(<svg[^>]+)>/,`$1>
			<defs><filter id="hapiblur"><feGaussianBlur result="blur" stdDeviation="${5*layer.blur/100}" /></filter></defs>
			<g filter="url(#hapiblur)">`
		);
		icon = icon.replace('</svg>',`</g></svg>`);
	}

	icon = 'data:image/svg+xml;base64,' + btoa(icon)

	const iconStyle = {
		anchor:anchor,
		imgSize:[iconSize,iconSize],
		size:[iconSize,iconSize],
		scale: 1,
		src: icon,
		opacity: layer.opacity || 1,
	}

	if(layer.color)
		iconStyle.color = layer.color;

	__style.push(new Style({
		zIndex: styleDef.zIndex,
		image: new Icon(iconStyle)
	}));
};

export  default icon_svg;